/**
 * Interfaces used across front
 */
export interface ImageEntity {
  auction: string
  image: string
  medium_image: string
  preload_image: string
  small_image: string
  thumbnail_image: string
  uuid: string
}

export interface ImagesEntity {
  image: ImageEntity
}

export enum VerifiedStateEnum {
  Unverified = 'unverified',
  Pending = 'pending',
  Verified = 'verified',
}

export enum VerificationMethodEnum {
  Both = 'both',
  Code = 'code',
  Link = 'link',
}

export interface GbDictionary<T> {
  [key: string]: T
}
